import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {BrowserRouter} from 'react-router-dom';
import {RecoilRoot} from 'recoil';
import {NavermapsProvider} from 'react-naver-maps';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {Preferences} from '@capacitor/preferences';

import reportWebVitals from './reportWebVitals';
import App from './App';
import './i18n';
import {ScrollContextProvider} from './services/contexts/ScrollContext';
import {GeoLocationProvider} from './services/contexts/GeolocationContext';
import {BrandListCollapsed} from './store/brand';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000, // 2분 동안 데이터를 신선한 상태로 유지
      gcTime: 5 * 60 * 1000, // 5분 동안 캐시 유지
      refetchOnWindowFocus: false, // 윈도우 포커스 시 자동 리페치 비활성화
    },
  },
});

async function initializeApp() {
  try {
    await Preferences.set({
      key: 'brandListCollapsed',
      value: 'true',
    });
    return Promise.resolve();
  } catch (error) {
    console.error('Failed to save initial collapsed state:', error);
    return Promise.resolve();
  }
}

initializeApp().then(() => {
  const rootElement = document.getElementById('root') as HTMLElement;
  const root = ReactDOM.createRoot(rootElement);

  // 앱 렌더링 먼저 수행
  root.render(
    <React.StrictMode>
      <RecoilRoot
        initializeState={({set}) => {
          set(BrandListCollapsed, {isCollapsed: true});
        }}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter basename={'/'}>
            <NavermapsProvider ncpClientId="6m7xk3g5yc">
              <GeoLocationProvider>
                <ScrollContextProvider>
                  <App />
                </ScrollContextProvider>
              </GeoLocationProvider>
            </NavermapsProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </RecoilRoot>
    </React.StrictMode>,
  );

  // 앱 렌더링 후 Sentry 초기화
  /*
  if (process.env.REACT_APP_ENV !== 'development') {
    // 지연 초기화를 위해 setTimeout 사용
    setTimeout(() => {
      Sentry.init({
        dsn: 'https://16e08b19073a4ce28fbf16241c48aed4@o1302410.ingest.us.sentry.io/6539779',
        release: process.env.REACT_APP_VERSION,
        environment: process.env.NODE_ENV,
        normalizeDepth: 6,
        integrations: [new BrowserTracing()],
        // 성능에 영향을 줄이기 위해 샘플링 비율 조정
        tracesSampleRate: 0.1,
      });
    }, 2000); // 2초 후 초기화
  }
  */
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
